import {useLocation, useNavigate} from 'react-router-dom';
import {locationState} from './type';

const PaymentFailure = () => {
  const navigate = useNavigate();
  const {state}: locationState = useLocation();
  const upgradeAdvertisementUrl = localStorage.getItem(
    'upgradeAdvertisementUrl',
  );

  return (
    <div className="w-full h-full flex flex-col bg-white justify-center items-center">
      <div className="flex w-[70%] h-full items-center justify-center flex-col gap-3">
        <img
          className="w-[104px] h-[104px]"
          src="https://s3.ir-thr-at1.arvanstorage.ir/payment/fail_payment.svg"
          alt="failure_image"
        />
        <p className="text-red-500 text-md font-Medium">پرداخت ناموفق</p>
        <div className="flex w-full border-dashed border-[1px] h-[1px] border-gray-300" />
        <p className="text-md font-Regular text-gray-900">
          پرداخت شما انجام نشد. لطفا مجددا تلاش کنید.
        </p>
      </div>
      <div className="w-full justify-between flex px-3 gap-3 pb-4">
        <button
          className="text-white text-md font-Medium rounded-[8px] bg-farm-shop-500 flex justify-center items-center h-[48px] w-full"
          onClick={() =>
            navigate(
              upgradeAdvertisementUrl
                ? `/${JSON.parse(upgradeAdvertisementUrl)}`
                : state.retryNavigate.route,
              {
                state: upgradeAdvertisementUrl
                  ? null
                  : state.retryNavigate.state,
              },
            )
          }
        >
          تلاش مجدد
        </button>
        <button
          className="text-farm-shop-500 text-md font-Medium  border-[1px] border-farm-shop-500 rounded-[8px] bg-white flex justify-center items-center h-[48px] w-full"
          onClick={() => navigate('/home')}
        >
          بازگشت به فروشگاه
        </button>
      </div>
    </div>
  );
};

export default PaymentFailure;
